module.exports = __webpack_public_path__ + "img/JXSdownload-logo.fc752f40.png";